/**
 * This resource types are deliberately kept inside select as the resource types will only have specific select specific data.
 * Right now as its not finalized it is kept here for safety. Later down the line if they are same as lookuptypes then we can move them
 * in a common file.
 */

// Constants
import { RESOURCE_TYPE } from '@tekion/tekion-base/bulkResolvers/constants/resourceType';
var RESOURCE_TYPES = {
  PARTS_N_PART_KITS: 'PARTS_N_PART_KITS',
  PART_N_PART_CORE: 'PART_N_PART_CORE',
  PARTS: RESOURCE_TYPE.PART,
  PART: RESOURCE_TYPE.PART,
  PART_KITS: RESOURCE_TYPE.PART_KIT,
  SERVICE_TYPE: RESOURCE_TYPE.SERVICE_TYPE,
  SERVICE_CATALOG_OPCODE: 'SERVICE_CATALOG_OPCODE',
  CUSTOMER: RESOURCE_TYPE.CUSTOMER,
  EMPLOYEE: RESOURCE_TYPE.EMPLOYEE,
  COUPON: RESOURCE_TYPE.COUPON,
  PARTS_SALE: 'PARTS_SALE',
  REPAIR_ORDER_ASSET: RESOURCE_TYPE.REPAIR_ORDER_ASSET,
  PARTINVENTORY: 'PARTINVENTORY',
  PARTANDINVENTORY: RESOURCE_TYPE.PARTANDINVENTORY,
  PARTMASTER: RESOURCE_TYPE.PARTMASTER,
  PARTSOURCECODE: 'PARTSOURCECODE',
  FEE: RESOURCE_TYPE.FEE,
  FEEV2: RESOURCE_TYPE.FEEV2,
  OPCODE: RESOURCE_TYPE.OPCODE,
  PARTSALES: RESOURCE_TYPE.PARTSALES,
  GMLABOROPCODE: RESOURCE_TYPE.GMLABOROPCODE,
  BINS: 'BINS',
  SHELVES: 'SHELVES',
  DRAWERS: 'DRAWERS',
  VENDOR_LIST: 'VENDOR_LIST',
  VENDOR: RESOURCE_TYPE.VENDOR,
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  VEHICLE: RESOURCE_TYPE.VEHICLE,
  DESCRIPTIVE_VEHICLE: RESOURCE_TYPE.VEHICLE,
  GL_ACCOUNT: RESOURCE_TYPE.GL_ACCOUNT_ASSET,
  DEALER_USER: RESOURCE_TYPE.DEALER_USER,
  PART_PRICE_CODE: RESOURCE_TYPE.PART_PRICE_CODE,
  SOR: 'SOR',
  VEHICLE_INTERIOR_COLOR: 'VEHICLE_INTERIOR_COLOR',
  VEHICLE_EXTERIOR_COLOR: 'VEHICLE_EXTERIOR_COLOR',
  CORE_INVENTORY: 'CORE_INVENTORY',
  VEHICLE_EXTERIOR_COLOR_HEXCODE: 'VEHICLE_EXTERIOR_COLOR_HEXCODE',
  SHIPMENT: 'SHIPMENT'
};
export default RESOURCE_TYPES;